

















// @ts-ignore
import { mapFields } from 'vuex-map-fields'
import SubscriptionCycleRadio from '@/views/admin/purchase/components/SubscriptionCycleRadio.vue'
import BillingInformationForm from '@/views/admin/purchase/components/BillingInformationForm.vue'
import AddonCycleEnum from '@/models/subscription/AddonCycleEnum'
import SetupWizardStepMixin from '@/mixins/setup-wizard-step-mixin'

export default {
  name: 'BillingSettings',
  components: { BillingInformationForm, SubscriptionCycleRadio },
  mixins: [SetupWizardStepMixin],
  computed: {
    ...mapFields('purchase', ['cycle', 'plan', 'features']),
    canUpgrade() {
      return this.$store.getters['purchase/canUpgrade']
    },
    showCycleSelect() {
      return (!!this.plan?.id && this.plan?.type !== 'free') || this.features.some((feature: any) => feature.cycle === AddonCycleEnum.BOTH)
    },
  },
  methods: {
    async submit() {
      // @ts-ignore
      const isValid = await this.$refs.address.validate()
      if (!isValid) {
        // @ts-ignore
        throw new Error(this.$tc('errors.field-invalid', 2))
      }
      return true
    },
  },
}
